// extracted by mini-css-extract-plugin
export default {"videoWrapper":"zWTFf0EoDs37No7ekNKc"};